/**
 * @file: orderFormFieldOf.ts
 * @copyright: (c) 2019-2026 sichuan zhichetech co., ltd.
 */

import type { OrderForm } from '../types';

/**
 * The order form input behind a field the create-order request names. The
 * request flattens the vehicle row into `vehicle*` fields and the service
 * agent into `source`, so the server's path is not always a form key.
 */
export function orderFormFieldOf(field: string): keyof OrderForm | undefined {
  if (field === 'vehicleMileage') return 'mileage';
  if (field.startsWith('source.serviceAgent')) return 'serviceAgentInfo';
  if (field.startsWith('vehicleInfo.') || /^vehicle[A-Z]/.test(field)) {
    return 'vehicleInfo';
  }
  return undefined;
}
